<template>
    <section class="all_categories_page random_bgimg">
        <!-- <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-3 courses_box" v-for="(item, index) in this.courseCategory"
            :key="index">
            <router-link :to="`/course/${item.slug}/`">
                <div class="courses_inner_wrp">
                <div class="courses_img" :style="{ backgroundImage: `url('${item.image}')` }">
                    <img
                    src="https://d242x28ee28y7t.cloudfront.net/media/category/AI%20and%20Machine%20Learning/course_img.jpg"
                    alt="" class="img-fluid">
                </div>
                <div class="courses_name">
                    <span v-if="item.name_html" v-html="item.name_html"></span>
                    <span v-else v-html="item.name"></span>
                </div>
                </div>
            </router-link>
            </div>
        </div> -->
        <div class="all_categories_section">
            <div class="container-fluid">
                <div class="content_box_wrp">
                    <div class="page_heading_wrp">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="page_heading">All Categories</h3>
                            </div>
                            <div class="col-3 ml-auto">
                                <div class="searchbar_box">
                                    <input type="text" class="form-control" placeholder="Search Category">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-md-3 col-lg-2">
                            <div class="courses_box">
                                <a href="/course/computer-science/" class="">
                                    <div class="courses_inner_wrp">
                                        <div class="courses_img">
                                            <img src="https://d242x28ee28y7t.cloudfront.net/media/category/AI%20and%20Machine%20Learning/course_img.jpg"
                                                alt="" class="img-fluid">
                                        </div>
                                        <div class="courses_name"><span>Computer Science</span></div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-2">
                            <div class="courses_box">
                                <a href="/course/finance/" class="">
                                    <div class="courses_inner_wrp">
                                        <div class="courses_img">
                                            <img src="https://d242x28ee28y7t.cloudfront.net/media/category/AI%20and%20Machine%20Learning/course_img.jpg"
                                                alt="" class="img-fluid">
                                        </div>
                                        <div class="courses_name"><span>Finance</span></div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-2">
                            <div class="courses_box">
                                <a href="/course/space-science/" class="">
                                    <div class="courses_inner_wrp">
                                        <div class="courses_img">
                                            <img src="https://d242x28ee28y7t.cloudfront.net/media/category/AI%20and%20Machine%20Learning/course_img.jpg"
                                                alt="" class="img-fluid">
                                        </div>
                                        <div class="courses_name"><span>Space Science</span></div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-2">
                            <div class="courses_box">
                                <a href="/course/computational-sciences/" class="">
                                    <div class="courses_inner_wrp">
                                        <div class="courses_img">
                                            <img src="https://d242x28ee28y7t.cloudfront.net/media/category/AI%20and%20Machine%20Learning/course_img.jpg"
                                                alt="" class="img-fluid">
                                        </div>
                                        <div class="courses_name"><span>Computational Sciences</span></div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-2">
                            <div class="courses_box">
                                <a href="/course/computational-sciences/" class="">
                                    <div class="courses_inner_wrp">
                                        <div class="courses_img">
                                            <img src="https://d242x28ee28y7t.cloudfront.net/media/category/AI%20and%20Machine%20Learning/course_img.jpg"
                                                alt="" class="img-fluid">
                                        </div>
                                        <div class="courses_name"><span>Computational Sciences</span></div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-2">
                            <div class="courses_box">
                                <a href="/course/computational-sciences/" class="">
                                    <div class="courses_inner_wrp">
                                        <div class="courses_img">
                                            <img src="https://d242x28ee28y7t.cloudfront.net/media/category/AI%20and%20Machine%20Learning/course_img.jpg"
                                                alt="" class="img-fluid">
                                        </div>
                                        <div class="courses_name"><span>Computational Sciences</span></div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-2">
                            <div class="courses_box">
                                <a href="/course/computational-sciences/" class="">
                                    <div class="courses_inner_wrp">
                                        <div class="courses_img">
                                            <img src="https://d242x28ee28y7t.cloudfront.net/media/category/AI%20and%20Machine%20Learning/course_img.jpg"
                                                alt="" class="img-fluid">
                                        </div>
                                        <div class="courses_name"><span>Computational Sciences</span></div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <appFooter></appFooter>
    </section>
</template>

<script>
/* eslint-disable */
import { bus } from '@/main';

import appFooter from '@/components/public/common/footer/';
import variation_random_img1 from '@/assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from '@/assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from '@/assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from '@/assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from '@/assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from '@/assets/images/random_img/oddnary-variation-6.jpg';
export default {
    name: 'all-categories',
    props: [],
    components: {
        appFooter
    },
    data() {
        return {
            courseCategory: []
        }
    },
    mounted() {
        bus.$emit('showHomeMenuBtn', true);
        this.randomImgLoaded();
    },
    methods: {
        randomImgLoaded() {
            const appLoader = document.querySelector('.app-loader');
            appLoader.style.display = 'block';

            // Multi Color Bg Img Of Section
            const images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"];
            const variationImages = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6];
            const size = images.length;
            const x = Math.floor(size * Math.random());
            this.imageIndex = x;
            const element = document.getElementsByClassName('random_bgimg')[0];

            if (x < images.length) {
                const navbarListWrp = document.querySelector('.navbar_list_wrp');
                navbarListWrp.classList.add(`act_contest_clr_of_holders${x}`);
                element.style.backgroundImage = `url(${variationImages[x]})`;

                setTimeout(() => {
                    this.preloader = false;
                    appLoader.style.display = 'none';
                }, 1500);
            }
        }
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
@import url("../../../assets/fonts/origintech-personal-use-webfont/stylesheet.css");

.all_categories_page {
    padding-top: 80px;
    .page_heading_wrp{
        padding: 15px;
        background:rgba(20,26,30,.6);
        border-radius: 3px;
        margin-bottom: 10px;
        .page_heading {
            color: #d29e00;
            font-size:28px;
            margin-bottom: 0;
            padding: 0px;
            font-family: "origin_tech_demoregular";
            line-height: 1;
        }
        .form-control{
            font-size: 18px;
            color: #3be8b0;
            font-family: 'MyriadProRegular',  sans-serif;
            border: 1px solid hsla(0, 0%, 100%, .1);
            width: 100%;
            line-height: 1;
            padding:12px 15px;
            height: auto;
            box-shadow: none;
            background:hsla(0,0%,100%,.08);
        }
    }
    .all_categories_section {
        min-height: calc(100vh - 80px);
        .content_box_wrp{
            background: rgba(0, 0, 0, 0.92);
            border-radius: 3px;
            padding:15px;
        }
        .courses_inner_wrp {
            background: rgba(24, 24, 24, 0.7);
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            border: 1px solid #2c2b2b;
            border-radius: 5px;
            margin: 10px 0;
            .courses_img {
                padding: 5px;

                .img-fluid {
                    height: 210px;
                    border-radius: 5px;
                    width: 100%;
                    object-fit: cover;
                    object-position: center center;
                }
            }

            .courses_name {
                display: table;
                width: 100%;
                min-height: 80px;
                text-align: center;
                border-top: 0;

                span {
                    display: table-cell;
                    vertical-align: middle;
                    font-size: 20px;
                    padding: 0 15px;
                    font-weight: 600;
                    line-height: 1.3;
                }
            }

            &:hover {
                background: #fff;
                color: #000000;

                .courses_name span {
                    font-weight: bold;
                }
            }
        }
    }
}
</style>